import React from 'react';
import { ICON_SIZE } from '@yme/atoms/svg-icon';
import { colorCoreBlack300, colorCoreBlack900Base } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularLinkLevel1, RegularTextLevel3 } from '@yme/tokens/typography';
import { BLANK, SELF } from '@yme/utils/constants';
import { getFileIconType, getFormattedFileSize } from './helpers';
import { SVGIconStyled } from './styled';
export function DownloadSectionItem(props) {
    const { filePath, type, name, size, isRightToLeft, isTargetBlank } = props;
    const formattedSize = getFormattedFileSize(size);
    const fileIconType = getFileIconType(type);
    return (React.createElement(FlexWrapper, { mt: "8px", gap: "8px", alignItems: "center" },
        React.createElement(SVGIconStyled, { size: ICON_SIZE.m, type: fileIconType, isRightToLeft: isRightToLeft }),
        React.createElement(RegularLinkLevel1, { href: filePath, target: isTargetBlank ? BLANK : SELF, color: colorCoreBlack900Base }, name),
        formattedSize && (React.createElement(RegularTextLevel3, { color: colorCoreBlack300 }, formattedSize))));
}
DownloadSectionItem.displayName = 'DownloadSectionItem_Component';
